import React from 'react';
import { Route,Routes, } from 'react-router-dom';

// Views
import ThirdParty from './Views/ThirdParty';
import LandingPage from './Views/LandingPage';
import KYCVerification from './Views/KYCVerification';
import Profile from './Views/Profile';
import BankDetails from './Views/BankDetails';
import AddressDetails from './Views/AddressDetails';
import NomineeDetails from './Views/NomineeDetails';
import PlanDetails from './Views/PlanDetails';
import Payment from './Views/Payment';
import Uploads from './Views/Uploads';
import ThirdPartyKYCVerification from './Views/ThirdPartyKYCVerification';
import Main from './Main';
import Review from './Views/Review';
import FinalSubmit from './Views/FinalSubmit';
import Scrutiny from './Views/Scrutiny';
import Objection from './Views/Objection';
import Courier from './Views/Courier';

export default function Routing() {
    return (
      <Routes>
        <Route exact path='/' element={<Main/>} />
        <Route exact path='/LandingPage' element={<LandingPage/>} />
        <Route exact path='/Login' element={<LandingPage path={"/Login"} />} />
        <Route exact path='/SignUp' element={<LandingPage path={"/SignUp"} />} />
        <Route exact path='/ThirdParty' element={<ThirdParty/>} />
        <Route exact path='/KYCVerification' element={<KYCVerification/>} />
        <Route exact path='/ThirdPartyKYCVerification' element={<ThirdPartyKYCVerification/>} />
        <Route exact path='/Profile' element={<Profile/>} />
        <Route exact path='/BankDetails' element={<BankDetails/>} />
        <Route exact path='/AddressDetails' element={<AddressDetails/>} />
        <Route exact path='/NomineeDetails' element={<NomineeDetails/>} />
        <Route exact path='/PlanDetails' element={<PlanDetails/>} /> 
        <Route exact path='/Payment' element={<Payment/>} />
        <Route exact path='/Upload' element={<Uploads/>} />
        <Route exact path='/Review' element={<Review/>} />
        <Route exact path='/Submit' element={<FinalSubmit/>} />
        <Route exact path='/Scrutiny' element={<Scrutiny/>} />
        <Route exact path='/Objection' element={<Objection/>} />
        <Route exact path='/Courier' element={<Courier/>} />
      </Routes>
    );
  }
